/* eslint-disable no-underscore-dangle */
import React, { useState } from "react";

import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import { ExcelRenderer } from "react-excel-renderer";
import { EPrimarySubmissionMethod, EReportType } from "../../../utils/types";
import PMSDromoUploader from "../../DromoUploader/PMSReport/PMSDromoUploader";

const TEMPLATE_PATH = `/excel-template/standard_report_list${
  process.env.REACT_APP_PLATFORM_TYPE === "MARRIOTT" ? "(marriott)" : ""
}.xlsx`;

const BulkPMSReportCreation = ({ dromoResultHandler, pmsData }) => {
  const [fileList, setFileList] = useState(null);

  const resultsHandler = (data) => {
    if (data && data.length > 0) {
      const editedDromoData = [];
      data.forEach((element) => {
        // check if the element["pms"] is valid one from pmsData
        const pms = pmsData?.find((pms) => pms.pms_name === element.pms);
        element.pms = pms ? pms._id : "";

        // check if the element["source_type"] is valid one from EPrimarySubmissionMethod
        const sourceType = Object.values(EPrimarySubmissionMethod).find(
          (submissionMethod) => submissionMethod === element.primary_submission_method,
        );
        element.source_type = sourceType
          ? element.primary_submission_method
          : "";

        delete element.primary_submission_method;

        // check if the element["report_type"] is valid one from EReportType
        const reportType = Object.values(EReportType).find(
          (myDocsReportType) => myDocsReportType === element.mydocs_report_type,
        );
        if (!reportType) {
          element.mydocs_report_type = "";
        }
        editedDromoData.push(element);
      });
      dromoResultHandler(editedDromoData);
    }
  };

  const beforeUpload = (event) => {
    let fileObj = event;

    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        console.log(err);
      } else {
        const sendData = [];

        if (resp && resp.rows) {
          let countOne = 0;
          let indexs = [];

          resp.rows.forEach((a) => {
            if (countOne == 0) {
              indexs = a;
            } else {
              let countTwo = 0;
              const sendObject = {};
              sendObject._id = countOne.toString();
              indexs.forEach((b) => {
                sendObject[b] = a[countTwo];
                countTwo++;
              });
              sendData.push(sendObject);
            }
            countOne++;
          });
        }
        resultsHandler(sendData)
        return false;
      }
    });
    return false;
  };

  const handleChange = (info) => {
    let fileList = [...info.fileList];

    // 1. Limit the number of uploaded files
    // Only to show two recent uploaded files, and old ones will be replaced by the new
    fileList = fileList.slice(-1);

    // 2. Read from response and show file link
    fileList = fileList.map((file) => {
      if (file.response) {
        // Component will show file.url as link
        file.url = file.response.url;
      }
      return file;
    });
    setFileList(fileList);
  };

  return (
    <>
      <div style={{ marginBottom: "20px" }}>
        <Button
          href={TEMPLATE_PATH}
          type="primary"
          shape="round"
          icon={<DownloadOutlined />}
          size="middle"
        >
          Download Template
        </Button>
      </div>
      {process.env.REACT_APP_PLATFORM_TYPE === "MARRIOTT" ? (
        <div style={{ marginBottom: "20px", width: "200px" }}>
          <Upload
            onChange={handleChange}
            beforeUpload={beforeUpload}
            accept=".xlsx"
            name="file"
            fileList={fileList}
          >
            <Button>
              <UploadOutlined />
              Click to Upload
            </Button>
          </Upload>
        </div>
      ) : (
        <div style={{ width: "200px", marginLeft: "10px" }}>
          <PMSDromoUploader resultsHandler={resultsHandler} />
        </div>
      )}
    </>
  );
};

export default BulkPMSReportCreation;
